import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/quickbooks/{creatorId}/service-items';

export type QuickBooksServiceItemsApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

/**
 * Hook to fetch available QuickBooks service items for a creator's connected realm.
 * Pass null params when the creator is not connected to skip the fetch.
 */
export const useQuickBooksServiceItems = (
  params: QuickBooksServiceItemsApi['params'] | null,
  config?: UseNoodleSwrConfig<QuickBooksServiceItemsApi['response']>,
): SWRResponse<QuickBooksServiceItemsApi['response'], ApiError> => {
  const path = params ? buildPath<QuickBooksServiceItemsApi>(PATH_TEMPLATE, params) : null;
  return useNoodleSwr(path, config);
};
